import React, { useState } from "react";
import questReputations from "../../utils/repMapping";
import { Link } from "react-router-dom";

const ReputationQuests = () => {
  const [showAvailable, setShowAvailable] = useState(true);
  const [showExpired, setShowExpired] = useState(false);

  const availableQuests = questReputations.filter((q) => !q.expired);
  const expiredQuests = questReputations.filter((q) => q.expired);

  const QuestList = ({ quests }) => (
    <ul className="space-y-1 ml-4 mt-2">
      {quests.map((quest) => (
        <li
          key={quest.id}
          className="flex justify-between font-semibold border-b border-gray-300 py-1 text-xs"
        >
          {quest.qstId ? <Link to={`/wiki/quests/${quest.qstId}`} target='_blank' rel='noreferrer'><span>{quest.name}</span></Link> : <span>{quest.name}</span>}
          <span className="text-blue-400 font-semibold">{quest.points} pts</span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="max-w-5xl wiki-text p-4 rounded-xl shadow-md">  
    <div className="flex flex-col md:flex-row gap-4">
      {/* Available Quests */}
      <div className="flex-1">
        <button
          className="w-full text-left font-semibold text-green-600 text-sm"
          onClick={() => setShowAvailable(!showAvailable)}
        >
          {showAvailable ? "▼" : "▶"} Available Quests ({availableQuests.length})
        </button>
        {showAvailable && <QuestList quests={availableQuests} />}
      </div>
  
      {/* Expired Quests */}
      <div className="flex-1">
        <button
          className="w-full text-left font-semibold text-orange-500 text-sm"
          onClick={() => setShowExpired(!showExpired)}
        >
          {showExpired ? "▼" : "▶"} Expired Quests ({expiredQuests.length})
        </button>
        {showExpired && <QuestList quests={expiredQuests} />}
      </div>
    </div>
  </div>
  
  );
};

export default ReputationQuests;
